import React, { FC, useState } from 'react'
import Select from 'react-select'
import SelectorStyles from 'tabs/nlp/constants/selectorStyles'
import { assignManager, getManagers } from '../../api/usersApi'
import { ManagerType, UserType } from '../../model/usersModel'

interface Props {
  manager: ManagerType
  user: UserType
  botId: string
  refreshUsers: () => void
  /** Logged-in Care Manager — view only. */
  isDisabled?: boolean
}

export const RoleSelector: FC<Props> = ({
  manager,
  user,
  botId,
  refreshUsers,
  isDisabled = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(manager)
  const [managers, setManagers] = useState<ManagerType[]>([])

  const onOpenHandler = async () => {
    if (isDisabled) return
    const fetchedManagers = await getManagers(botId)
    const filteredManagers = fetchedManagers.filter(
      (manager: { value: number }) => manager.value !== user.id
    )
    setManagers(filteredManagers)
  }

  const onChangeHandler = (selectedValue) => {
    if (isDisabled) return
    setSelectedValue(selectedValue)
    assignManager(botId, user.id, selectedValue.value).then(() => {
      refreshUsers()
    })
  }

  return (
    <Select
      isSearchable={true}
      isDisabled={isDisabled}
      options={managers}
      value={selectedValue?.label ? selectedValue : null}
      onChange={onChangeHandler}
      onMenuOpen={onOpenHandler}
      placeholder='Assign a manager'
      styles={{
        ...SelectorStyles,
        indicatorSeparator: provided => ({
          ...provided,
          display: 'none',
        })
      }}
    />
  )
}
